module.exports = __webpack_public_path__ + "assets/img/1e71d45f53523f02d74fff3a5c4e940d.png";